<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px" id="docksContainer">
    <h2 fxFlex="100%" fxLayout="row" class="page-header left">Mantenimiento de Dock</h2>
    <div fxFlex="100%" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-md="column" class="right">
        <button mat-icon-button color="primary" (click)="addSelected()" *ngIf="canEdit">
            <mat-icon title='Agregar fila'>add_circle</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="onSubmit()" [disabled]="disablSaveButton" *ngIf="canEdit">
            <mat-icon title='Salvar'>save</mat-icon>
        </button>
<!--        <button mat-icon-button color="primary" (click)="onRefresh()" [disabled]="disablRefreshButton" >-->
<!--            <mat-icon title='Actualizar'>refresh</mat-icon>-->
<!--        </button>-->
    </div>


    <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>

    <div #tableContainer class="table-height">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="dock">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Dock
                    <rem-string-filter #tableFilter columnDef="dock" [operators]="operators"
                                       (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-smtext">
                    <div *ngIf="element.added === false">
                        {{element.dock}}
                    </div>
                    <div *ngIf="element.added === true">
                        <mat-form-field class="cell-width-smtext">
                            <input class="mat-column-docks" matInput maxlength="5" [(ngModel)]="element.dock" required
                                   (input)="onChange(element)" autocomplete="off">
                        </mat-form-field>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="descCompDock">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción Dock
                    <rem-string-filter #tableFilter columnDef="descCompDock" [operators]="operators"
                                       (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div *ngIf="element.added === false">
                        {{element.descCompDock}}
                    </div>
                    <div *ngIf="element.added === true">
                        <mat-form-field class="cell-width-description">
                            <input matInput maxlength="40" [(ngModel)]="element.descCompDock" required autocomplete="off"
                                   (input)="onChange(element)"/>
                        </mat-form-field>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="dunsDock">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Duns Dock
                    <rem-string-filter #tableFilter columnDef="dunsDock" [operators]="operators"
                                       (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
                    <div *ngIf="element.added === false">
                        {{element.dunsDock}}
                    </div>
                    <div *ngIf="element.added === true">
                        <mat-form-field class="cell-width-lgtext">
                            <input matInput maxlength="9" minlength="9" [(ngModel)]="element.dunsDock" required autocomplete="off"
                                   (input)="onChange(element)"/>
                        </mat-form-field>
                    </div>

                </td>
            </ng-container>

            <ng-container matColumnDef="ptoEmision">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> PTO Emision
                  <rem-string-filter #tableFilter columnDef="ptoEmision" [operators]="operators"
                                     (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-mtext">
                    <div *ngIf="!element.added; else ptoEmisionBox">
                        {{element.ptoEmision}}
                    </div>
                    <ng-template #ptoEmisionBox>
                      <mat-form-field class="cell-width-mtext">
                        <mat-select name="ptoEmision" [(ngModel)]="element.ptoEmision" required disableOptionCentering
                                   (input)="onChange(element)">
                          <mat-option *ngFor="let ptoEmision of ptoEmisions" [value]="ptoEmision.code">{{ ptoEmision.code }}</mat-option>

                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="balanza">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Balanza
                  <rem-string-filter #tableFilter columnDef="balanza" [operators]="operators"
                                     (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-smtext">
                    <div *ngIf="element.added === false">
                        {{element.balanza}}
                    </div>
                    <mat-form-field *ngIf="element.added === true" class="cell-width-lgtext">
                        <mat-select [(ngModel)]="element.balanza" name="balanza"
                                    (ngModelChange)="onChange(element)"
                                    required>
                            <mat-option *ngFor="let balanza of balanzas" [value]="balanza.value">
                                {{ balanza.valueType }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="fecCreacion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Creación
                  <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                                   (filterChange)="filterChange($event);"></rem-date-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
                    <div *ngIf="element.added === false">
                        {{element.fecCreacion  | customDate}}
                    </div>
                    <div *ngIf="element.added === true" (input)="onChange(element)" class="cell-width-lgtext">
                        <span>{{date | customDate}}</span>
                    </div>
                    <div *ngIf="element.edit === true">

                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="usrCreacion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Creación
                  <rem-string-filter #tableFilter columnDef="usrCreacion" [operators]="operators"
                                     (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
                    <div *ngIf="element.added === false">
                        {{element.usrCreacion}}
                    </div>
                    <div *ngIf="element.added === true && element.edit === false ">
                        <span>{{this.user}}</span>
                    </div>
                    <div *ngIf="element.edit === true && element.added === true ">
                        <span>{{this.user}}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="fecModif">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Modificación
                  <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                                   (filterChange)="filterChange($event);"></rem-date-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
                    <div *ngIf="element.estado === false">
                        {{this.date | customDate }}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="usrModif">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Modificación
                  <rem-string-filter #tableFilter columnDef="usrModif" [operators]="operators"
                                     (filterChange)="filterChange($event);"></rem-string-filter>
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
                    <div *ngIf="element.estado === false">
                        {{this.user}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
                    <div *ngIf="element.added === false && element.edit === false">
                                                <span *ngIf="element.estado === true">Active</span>
                                                <span *ngIf="element.estado === false">Inactive</span>
                    </div>
                                        <div *ngIf="element.added === true && element.edit === false">
                                            <span>Active</span>
                                        </div>
                                        <div  *ngIf="element.edit === true && element.added ===false">
                    <mat-form-field *ngIf="element.edit === true" class="cell-width-lgtext">
                        <mat-select [(ngModel)]="element.estado" name="estado"
                                    (ngModelChange)="onChange(element)"
                                    required>
                            <mat-option *ngFor="let estado of estados" [value]="estado.value">
                                {{ estado.valueType }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matPrefix *ngIf="element.estado !== true"
                                  color="warn" class="dirty-indicator">info
                        </mat-icon>
                    </mat-form-field>
                                        </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="isEdit">
                <th mat-header-cell *matHeaderCellDef [hidden]="!canEdit">
                </th>
                <td mat-cell *matCellDef="let element" class="cell-width-smtext" [hidden]="!canEdit">
                    <div class="btn-edit">
                        <div *ngIf="element.added === false && element.edit === false" [hidden]="element.inactive === true">
                            <button mat-icon-button color="secondary" (click)="editRow(element)">
                                <mat-icon title='Edit'>create</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="btn-edit">
                        <div *ngIf="element.added === true || element.edit === true">
                            <button mat-icon-button color="tertiary" (click)="cancelRow(element)"
                                    class="cell-width-smtext">
                                <mat-icon title='Cancel'>cancel</mat-icon>
                            </button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
        </table>
    </div>
    <mat-paginator #paginator
                   [pageSize]="10"
                   [pageSizeOptions]="[10, 15, 20, 25]">
    </mat-paginator>
</div>
